import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Box from '@mui/material/Box'

import { pxToEm } from '../../helpers'

import { selectPage } from '../pages/pagesSlice'
import {
  addPositionToStikis,
  selectAllSelectedStikisOnPage,
  updateDirtyStikisAsync,
} from './stikisSlice'
import {
  updateStikisMove,
  endStikisMove,
  selectStikisMove,
  selectStikisMovePosition,
} from '../ui/uiSlice'

export default function StikisMoveEventWrapper({ pageId, children }) {
  const dispatch = useDispatch()

  ///////////////////////////////////////////////
  //
  // State
  //

  const stikisMove = useSelector(selectStikisMove)
  const position = useSelector(selectStikisMovePosition)
  const page = useSelector(selectPage(pageId))
  const selectedStikisSelector = useMemo(
    () => selectAllSelectedStikisOnPage(pageId),
    [pageId]
  )
  const selectedStikis = useSelector(selectedStikisSelector)
  const [hasMoved, setHasMoved] = useState(false)

  ///////////////////////////////////////////////
  //
  // Events
  //

  // const handleMouseDown = (e) => {
  //   // console.log('<StikisMoverEventWrapper/>.handleMouseDown()')
  // }

  const handleMouseMove = (e) => {
    if (stikisMove.isMoving) {
      // console.log('<StikisMoveEventWrapper/>.handleMouseMove()')
      setHasMoved(true)
      dispatch(
        updateStikisMove({
          x: e.pageX - stikisMove.start.x,
          y: e.pageY - stikisMove.start.y,
        })
      )
    }
  }

  const handleMouseUp = (e) => {
    if (stikisMove.isMoving) {
      // console.log('<StikisMoveEventWrapper/>.handleMouseUp()')

      if (hasMoved) {
        setHasMoved(false)
        dispatch(
          addPositionToStikis({
            stikiIds: selectedStikis,
            position: {
              x: pxToEm(position.x, page.zoom),
              y: pxToEm(position.y, page.zoom),
            },
          })
        )
        dispatch(updateDirtyStikisAsync(pageId))
      }
      dispatch(endStikisMove())

      e.preventDefault()
      e.stopPropagation()
    }
  }

  // A move has to end wherever the button is let go. The handler below only sees
  // a mouse-up that reaches this element, and a stiki's own buttons stop the
  // event, so releasing over one of those left the move running: the stiki went
  // on following the pointer with no button held, the cursor stayed as whatever
  // it was over, and clicking again only started another move. Watching the
  // window while a move is in progress ends it wherever it happens — the same
  // fix as panning in StikisField.
  useEffect(() => {
    if (!stikisMove.isMoving) {
      return undefined
    }

    const endMove = (e) => handleMouseUp(e)
    window.addEventListener('mouseup', endMove)
    return () => window.removeEventListener('mouseup', endMove)
  }, [stikisMove.isMoving, hasMoved, position, selectedStikis, pageId, page.zoom])

  ///////////////////////////////////////////////
  //
  // Markup
  //

  return (
    <Box
      sx={{ position: 'absolute', inset: 0 }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {children}
    </Box>
  )
}
